<template>
    <v-row dense class="category-list-buttons">
        <v-col
            v-for="(category, key) in categoryList"
            :key="key"
            cols="12"
            sm="3">
            <template v-if="hasSubCategory(category.children) && isMediumAndUp">
                <v-menu 
                    open-on-click
                    offset-y
                    :nudge-left="calculateNudgeLeft(category)"
                    :transition="false"
                    max-width="90%"
                    v-model="category.menuOpen">

                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :outlined="key > (rowItemsLimit - 1)"
                            block
                            :x-large="xLargeButtons"
                            color="primary"
                            v-on="on"
                            aria-haspopup="true"
                            :aria-expanded="category.menuOpen">
                            {{ category.name }} <v-icon>arrow_drop_down</v-icon>
                        </v-btn>
                    </template>

                    <v-list :style="calculateColumnCountStyle(category)" class="list_with_cols">
                        <v-list-item :href="getCategoryUrlFromSlug(category.slug)">
                            <v-list-item-title>Browse All {{ category.name }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-for="(subcategory, index) in category.children"
                            :key="index"
                            :href="getCategoryUrlFromSlug(subcategory.slug)">
                            <v-list-item-title>{{ subcategory.name }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>

            <template v-else>
                <v-btn
                    :outlined="true"
                    block
                    :x-large="xLargeButtons"
                    color="primary"
                    @click="visitCategory(category.slug)">
                    {{ category.name }}
                </v-btn>
            </template>
        </v-col>
    </v-row>
</template>

<script>
import Mobile from "../../inc/mixins/mobile";
import Categories from "../../inc/mixins/categories";
import CategoryManager from "../../inc/managers/CategoryManager";

export default {
    mixins: [Mobile, Categories],
    data() {
        return {
            categoryList: []
        };
    },
    props: {
        xLargeButtons: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        rowItemsLimit() {
            console.log(this.categoryList.length)
            return this.categoryList.length / 2;
        }
    },
    methods: {
        calculateNudgeLeft(category) {
            let cols = Math.ceil(category.children.length / 10);
            return cols < 2 ? 0 : Math.round(cols / 2) * 120;
        },
        calculateColumnCountStyle(category) {
            let cols = Math.ceil(category.children.length / 10);
            return `column-count: ${cols};`;
        },
        getCategoryUrlFromSlug(slug) {
            return this.getRoute("codes_category", { category: slug });
        },
        visitCategory(slug) {
            this.goToRoute("codes_category", { category: slug });
        },
        populateCategories() {
            this.categoryList = CategoryManager.getAllLinks(this.$store, this.sortedCategories);
        },
        hasSubCategory(val) {
            return val && val.length > 0;
        }
    },
    mounted() {
        this.populateCategories();
    }
};
</script>

<style scoped>
.list_with_cols > a {
    break-inside: avoid-column; /* for Chrome and Edge */
}

.category-list-buttons {
    .v-btn--block {
        &:focus {
            outline: 3px solid var(--v-cdpBlue-base) !important;
            outline-offset: 1px;
        }
    }
}
</style>
